type AutoRefreshSubscriber = (enabled: boolean) => void;

// Auto-refresh / "Auto Sync" is OFF by default on the doctor-facing worklists (PACS list +
// My Worklist) so background refetches don't disrupt radiologists mid-action. Users can turn
// it ON via the header "Auto Sync" switch; the choice lasts for the session (not persisted).
let autoRefreshEnabled = false;
const subscribers = new Set<AutoRefreshSubscriber>();

export const getAutoRefreshEnabled = (): boolean => autoRefreshEnabled;

export const publishAutoRefresh = (enabled: boolean): void => {
  autoRefreshEnabled = enabled;
  subscribers.forEach(callback => {
    try {
      callback(enabled);
    } catch (error) {
      console.error('[autoRefreshPubSub] subscriber error', error);
    }
  });
};

export const subscribeAutoRefresh = (
  callback: AutoRefreshSubscriber,
  emitCurrent = true
): (() => void) => {
  subscribers.add(callback);

  if (emitCurrent) {
    callback(autoRefreshEnabled);
  }

  return () => {
    subscribers.delete(callback);
  };
};
